// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { FileLocationDTO } from '../models';
/**
 * IntegratorCommissionApi - axios parameter creator
 * @export
 */
export const IntegratorCommissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate last months commision for an integrator
         * @param {string} integratorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLastMonthCommission(integratorId: string, options: any = {}): RequestArgs {
            // verify required parameter 'integratorId' is not null or undefined
            if (integratorId === null || integratorId === undefined) {
                throw new RequiredError('integratorId','Required parameter integratorId was null or undefined when calling generateLastMonthCommission.');
            }
            const localVarPath = `/v2/integrator/{integratorId}/commission`
                .replace(`{${"integratorId"}}`, encodeURIComponent(String(integratorId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegratorCommissionApi - functional programming interface
 * @export
 */
export const IntegratorCommissionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Generate last months commision for an integrator
         * @param {string} integratorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLastMonthCommission(integratorId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileLocationDTO> {
            const localVarAxiosArgs = IntegratorCommissionApiAxiosParamCreator(configuration).generateLastMonthCommission(integratorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IntegratorCommissionApi - factory interface
 * @export
 */
export const IntegratorCommissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Generate last months commision for an integrator
         * @param {string} integratorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLastMonthCommission(integratorId: string, options?: any) {
            return IntegratorCommissionApiFp(configuration).generateLastMonthCommission(integratorId, options)(axios, basePath);
        },
    };
};

/**
 * IntegratorCommissionApi - interface
 * @export
 * @interface IntegratorCommissionApi
 */
export interface IntegratorCommissionApiInterface {
    /**
     * Generate last months commision for an integrator
     * @param {string} integratorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegratorCommissionApiInterface
     */
    generateLastMonthCommission(integratorId: string, options?: any): AxiosPromise<FileLocationDTO>;

}

/**
 * IntegratorCommissionApi - object-oriented interface
 * @export
 * @class IntegratorCommissionApi
 * @extends {BaseAPI}
 */
export class IntegratorCommissionApi extends BaseAPI implements IntegratorCommissionApiInterface {
    /**
     * Generate last months commision for an integrator
     * @param {string} integratorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegratorCommissionApi
     */
    public generateLastMonthCommission(integratorId: string, options?: any) {
        return IntegratorCommissionApiFp(this.configuration).generateLastMonthCommission(integratorId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for IntegratorCommissionApi
 * Import individual functions for optimal bundle size
 */
/**
 * Generate last months commision for an integrator
 * @param {string} integratorId 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function generateLastMonthCommission(
    integratorId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<FileLocationDTO> {
    const localVarAxiosArgs = IntegratorCommissionApiAxiosParamCreator(configuration).generateLastMonthCommission(integratorId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

